import axios from "axios";

import IAdress from "../interfaces/adress";

export class HelperCep {
  static async getAdressByCep(cep: string): Promise<Partial<IAdress> | null> {
    const cleanCep = cep.replace(/\D/g, "");
    const apiUrl = `https://viacep.com.br/ws/${cleanCep}/json`;

    try {
      const response = await axios.get(apiUrl);
      const { logradouro, complemento, bairro, localidade, uf } = response.data;
      return {
        zipcode: cep,
        street: logradouro,
        complement: complemento,
        neighborhood: bairro,
        city: localidade,
        state: uf,
      };
    } catch (error) {
      return {
        zipcode: "",
        street: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
      };
    }
  }

  static isValidCep = (cep: string): boolean => cep.length === 8;
}

export default HelperCep;
